export const PRODUCTION_REPORTS = {
  BY_SELL_CHANNEL: 1,
  BY_DRIVER: 2,
  BY_VEHICLE: 3
}

export const DRIVER_REPORTS = {
  DAY: '1',
  WEEK: '2',
  LAST_WEEK: '3'
}

export const SERVICES_REPORTS = {
  BY_PURCHASE_DATE: '1',
  BY_ASSIGMENT_DATE: '2'  
}